export default __webpack_public_path__ + "static/media/hdb-construction-completed.49fe527d.svg";